import { Box, Typography } from '@mui/material';
import { formatMessage } from 'cw-ui-core';
import PropTypes from 'prop-types';
import React from 'react';
import Locale from 'src/Locale';

const AsioSuccessStep = props => {
  const renderText = (
    text,
    variant = 'paragraph',
    fontSize = '14px',
    marginBottom = '16px'
  ) => (
    <Typography
      variant={variant}
      fontSize={fontSize}
      pl="16px"
      marginBottom={marginBottom}
      fontWeight="300"
      color="#767786"
      lineHeight="18px"
      sx={{ fontFamily: 'sans-serif' }}
    >
      {formatMessage(text)}
    </Typography>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        marginTop: '30px',
        flexDirection: 'column'
      }}
    >
      <Typography
        fontWeight="300"
        pl="16px"
        fontSize="26px"
        sx={{ fontFamily: 'sans-serif' }}
      >
        {formatMessage(Locale.asio_success_step_title)}
      </Typography>
      <Typography
        fontWeight="300"
        pl="16px"
        fontSize="26px"
        sx={{ fontFamily: 'sans-serif' }}
      >
        {props.showNewTitle
          ? formatMessage(Locale.asio_success_step_title2_alternate)
          : (props.isFullAccountUpgrade || (props.isAutomateInAsioUpgrade && props.selectedFeature !== 'automate'))
          ? formatMessage(Locale.asio_success_step_title2_full_upgrade_text)
          : formatMessage(Locale.asio_success_step_title2)}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            pr: '8px',
            width: '50%',
            justifyContent: 'center'
          }}
        >
          {(props.isFullAccountUpgrade || (props.isAutomateInAsioUpgrade && props.selectedFeature !== 'automate')) && renderText(Locale.asio_success_step_sub_full_account_upgrade_text)}
          {!(props.isFullAccountUpgrade || (props.isAutomateInAsioUpgrade && props.selectedFeature !== 'automate')) && renderText(Locale.asio_success_step_sub)}
          {!(props.isFullAccountUpgrade || (props.isAutomateInAsioUpgrade && props.selectedFeature !== 'automate')) && renderText(Locale.asio_success_step_sub2)}
          {renderText(Locale.asio_success_step_sub3)}
        </Box>
        <Box
          sx={{
            display: 'flex',
            pl: '8px',
            width: '50%',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box
            component="img"
            src="/images/AsioPage/DialogSuccess.png"
            width="100%"
            height="100%"
            alt="Success"
          />
        </Box>
      </Box>
    </Box>
  );
};

AsioSuccessStep.propTypes = {
  showNewTitle: PropTypes.bool,
  isFullAccountUpgrade: PropTypes.bool,
  isAutomateInAsioUpgrade: PropTypes.bool
};

export default AsioSuccessStep;
